export const loadGoogleAnalytics = (measurementId) => {
  if (window.gtag) return; // Evita caricamenti doppi

  const scriptTag = document.createElement("script");
  scriptTag.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  scriptTag.async = true;
  document.head.appendChild(scriptTag);

  scriptTag.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag(){ window.dataLayer.push(arguments); }
    window.gtag = gtag;

    gtag('js', new Date());
    gtag('config', measurementId);
  };
};